import { render, staticRenderFns } from "./AddTaskFrom.vue?vue&type=template&id=409bb030&"
import script from "./AddTaskFrom.vue?vue&type=script&lang=js&"
export * from "./AddTaskFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports